const CONSTANTS = {
  UNITRIP_BLOG_URL: "https://www.unitrip.ai",
};

export default CONSTANTS;
